// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__IwGFH","logo":"Header_logo__1Hs_S","crowd":"Header_crowd__2Afrl"};